import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import StaticBackground from './components/StaticBackground/StaticBackground';
import Home from './pages/Home';
import './styles/base/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <StaticBackground />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;